import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ngxParcelId' })
export class ParcelIdPipe implements PipeTransform {
  transform(input: any): string {
    const x = input.toString();
    if (x.length === 11) {
      const first = x.substring(0, 9);
      const last = x.substring(9);
      input = first + '-' + last;
    }
    return input;
  }
}

